module.exports = __webpack_public_path__ + "media/images/pillar_site-aa5e8f97442bbf6ba9be9f7e900eb5c9.jpg";